import type { StatusGroupRes } from 'api/swagger';

export const generateDateString = (dateFrom: string, dateTo: string): string => {
  return dateFrom === dateTo ? dateFrom : `${dateFrom} / ${dateTo}`;
};

export const isCargoInProgress = (statuses: StatusGroupRes[]) =>
  statuses.some((status) => {
    const { type, fromWarehouseId, toWarehouseId } = status;

    const isFromClientToWarehouse = !fromWarehouseId && toWarehouseId;
    const isFromWarehouseToClient = fromWarehouseId && !toWarehouseId;
    const isFTL = !fromWarehouseId && !toWarehouseId;

    if (type === 'loaded') {
      return isFromClientToWarehouse || isFTL || isFromWarehouseToClient;
    }

    if (type === 'planned') {
      return isFromClientToWarehouse;
    }

    return false;
  });
